import * as Sentry from '@sentry/react';
import { useElectronPrintersActions } from '@store/actions/electronPrinters';
import { useEffect } from 'react';
import { useElectron } from './useElectron';
import toast from 'react-hot-toast';
import { ElectronPrinter } from '@interfaces/general';

// Refresca la lista de impresoras detectadas (IPC getPrinters) SIN efecto de
// montaje. Úsalo para el botón "Actualizar lista" sin disparar un fetch
// redundante (la inicialización global vive en Layout vía useInitElectronPrinters).
export const useRefreshElectronPrinters = () => {
  const { initElectronPrinters } = useElectronPrintersActions();
  const { isElectronInstance, ipcRenderer } = useElectron();

  return async () => {
    if (!isElectronInstance) return;
    try {
      const printers: ElectronPrinter[] = await ipcRenderer.invoke('getPrinters');
      initElectronPrinters(printers);
    } catch (error) {
      Sentry.captureMessage('Error al leer las impresoras instaladas');
      Sentry.captureException(error);
      toast.error('Error al leer las impresoras instaladas');
    }
  };
};

// Inicialización global (una sola vez, en Layout): detecta impresoras al montar.
export const useInitElectronPrinters = () => {
  const { isElectronInstance } = useElectron();
  const refreshPrinters = useRefreshElectronPrinters();

  useEffect(() => {
    if (isElectronInstance) {
      refreshPrinters();
    }
  }, [isElectronInstance]);
};
